import React from "react";
import { Row, Col } from "../../components/Component";
import { Link } from "react-router-dom";
import AfrocentecLogo from "../../images/afrocentec_logo.png";
import Katundu360Logo from "../../images/logo.png";

const AuthFooter = ({ tenant_name }) => {
  return (
    <footer className="nk-footer nk-auth-footer-full py-4 border-top">
      <div className="container wide-lg">
        <Row className="g-3 align-items-center">
          <Col lg={12}>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              {/* Copyright and Links */}
              <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2 gap-md-3">
                <span className="text-soft">
                  &copy; {new Date().getFullYear()} {tenant_name || "Company"}. All Rights Reserved.
                </span>

                <div className="d-flex gap-2 gap-md-3">
                  <Link
                    className="text-soft hover-primary text-decoration-none"
                    to="/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms
                  </Link>
                  <Link
                    className="text-soft hover-primary text-decoration-none"
                    to="/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy
                  </Link>
                  <Link
                    className="text-soft hover-primary text-decoration-none"
                    to="/help"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help
                  </Link>
                </div>
              </div>

              {/* Powered by and Developed by sections */}
              <div className="d-flex flex-column flex-sm-row align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="text-soft small">Powered by</span>
                  <img
                    src={Katundu360Logo}
                    alt="Katundu360"
                    className="img-fluid"
                    style={{ height: "24px", width: "auto" }}
                  />
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="text-soft small">Developed by</span>
                  <a
                    href="https://afrocentec.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover-opacity-75"
                  >
                    <img
                      src={AfrocentecLogo}
                      alt="Afrocentec"
                      className="img-fluid"
                      style={{ height: "24px", width: "auto" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default AuthFooter;